var Ce = Object.defineProperty;
var r = (e, t) => Ce(e, "name", { value: t, configurable: !0 });
var De = Object.defineProperty, n = /* @__PURE__ */ r((e, t) => De(e, "name", { value: t, configurable: !0 }), "t"), q = typeof global == "object" && global && global.Object === Object && global, Me = typeof self == "object" && self && self.Object === Object && self, i = q || Me || Function("return this")(), p = i.Symbol, J = Object.prototype, Ne = J.hasOwnProperty, Ze = J.toString, d = p ? p.toStringTag : void 0;
function K(e) {
  var t = Ne.call(e, d), o = e[d];
  try {
    e[d] = void 0;
    var c = !0;
  } catch {
  }
  var a = Ze.call(e);
  return c && (t ? e[d] = o : delete e[d]), a;
}
r(K, "jr");
n(K, "getRawTag");
var _e = Object.prototype, $e = _e.toString;
function Q(e) {
  return $e.call(e);
}
r(Q, "vr");
n(Q, "objectToString");
var We = "[object Null]", Ge = "[object Undefined]", k = p ? p.toStringTag : void 0;
function b(e) {
  return e == null ? e === void 0 ? Ge : We : k && k in Object(e) ? K(e) : Q(e);
}
r(b, "b");
n(b, "baseGetTag");
function v(e) {
  return e != null && typeof e == "object";
}
r(v, "y");
n(v, "isObjectLike");
var Be = "[object Symbol]";
function X(e) {
  return typeof e == "symbol" || v(e) && b(e) == Be;
}
r(X, "hr");
n(X, "isSymbol");
function ee(e, t) {
  for (var o = -1, c = e == null ? 0 : e.length, a = Array(c); ++o < c; )
    a[o] = t(e[o], o, e);
  return a;
}
r(ee, "$r");
n(ee, "arrayMap");
var te = Array.isArray, z = p ? p.prototype : void 0, F = z ? z.toString : void 0;
function E(e) {
  if (typeof e == "string")
    return e;
  if (te(e))
    return ee(e, E) + "";
  if (X(e))
    return F ? F.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
r(E, "G");
n(E, "baseToString");
function w(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
r(w, "H");
n(w, "isObject");
var Ve = "[object AsyncFunction]", He = "[object Function]", Ye = "[object GeneratorFunction]", qe = "[object Proxy]";
function I(e) {
  if (!w(e))
    return !1;
  var t = b(e);
  return t == He || t == Ye || t == Ve || t == qe;
}
r(I, "J");
n(I, "isFunction");
var g = i["__core-js_shared__"], L = function() {
  var e = /[^.]+$/.exec(g && g.keys && g.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function re(e) {
  return !!L && L in e;
}
r(re, "Er");
n(re, "isMasked");
var Je = Function.prototype, Ke = Je.toString;
function f(e) {
  if (e != null) {
    try {
      return Ke.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
r(f, "f");
n(f, "toSource");
var Qe = /[\\^$.*+?()[\]{}|]/g, Xe = /^\[object .+?Constructor\]$/, et = Function.prototype, tt = Object.prototype, rt = et.toString, nt = tt.hasOwnProperty, ot = RegExp(
  "^" + rt.call(nt).replace(Qe, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function ne(e) {
  if (!w(e) || re(e))
    return !1;
  var t = I(e) ? ot : Xe;
  return t.test(f(e));
}
r(ne, "Wr");
n(ne, "baseIsNative");
function oe(e, t) {
  return e == null ? void 0 : e[t];
}
r(oe, "Br");
n(oe, "getValue");
function y(e, t) {
  var o = oe(e, t);
  return ne(o) ? o : void 0;
}
r(y, "x");
n(y, "getNative");
var A = y(i, "WeakMap"), ut = 9007199254740991;
function U(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= ut;
}
r(U, "K");
n(U, "isLength");
function ue(e) {
  return e != null && U(e.length) && !I(e);
}
r(ue, "Zr");
n(ue, "isArrayLike");
var ct = Object.prototype;
function P(e) {
  var t = e && e.constructor, o = typeof t == "function" && t.prototype || ct;
  return e === o;
}
r(P, "q");
n(P, "isPrototype");
var at = "[object Arguments]";
function O(e) {
  return v(e) && b(e) == at;
}
r(O, "R");
n(O, "baseIsArguments");
var ce = Object.prototype, it = ce.hasOwnProperty, ft = ce.propertyIsEnumerable, lt = O(/* @__PURE__ */ function() {
  return arguments;
}()) ? O : function(e) {
  return v(e) && it.call(e, "callee") && !ft.call(e, "callee");
};
function ae() {
  return !1;
}
r(ae, "qr");
n(ae, "stubFalse");
var ie = typeof exports == "object" && exports && !exports.nodeType && exports, C = ie && typeof module == "object" && module && !module.nodeType && module, bt = C && C.exports === ie, D = bt ? i.Buffer : void 0, st = D ? D.isBuffer : void 0, pt = st || ae, yt = "[object Arguments]", dt = "[object Array]", jt = "[object Boolean]", vt = "[object Date]", gt = "[object Error]", xt = "[object Function]", At = "[object Map]", Ot = "[object Number]", ht = "[object Object]", mt = "[object RegExp]", St = "[object Set]", Tt = "[object String]", Et = "[object WeakMap]", wt = "[object ArrayBuffer]", It = "[object DataView]", Ut = "[object Float32Array]", Pt = "[object Float64Array]", Rt = "[object Int8Array]", kt = "[object Int16Array]", zt = "[object Int32Array]", Ft = "[object Uint8Array]", Lt = "[object Uint8ClampedArray]", Ct = "[object Uint16Array]", Dt = "[object Uint32Array]", u = {};
u[Ut] = u[Pt] = u[Rt] = u[kt] = u[zt] = u[Ft] = u[Lt] = u[Ct] = u[Dt] = !0;
u[yt] = u[dt] = u[wt] = u[jt] = u[It] = u[vt] = u[gt] = u[xt] = u[At] = u[Ot] = u[ht] = u[mt] = u[St] = u[Tt] = u[Et] = !1;
function fe(e) {
  return v(e) && U(e.length) && !!u[b(e)];
}
r(fe, "Se");
n(fe, "baseIsTypedArray");
function le(e) {
  return function(t) {
    return e(t);
  };
}
r(le, "he");
n(le, "baseUnary");
var be = typeof exports == "object" && exports && !exports.nodeType && exports, j = be && typeof module == "object" && module && !module.nodeType && module, Mt = j && j.exports === be, x = Mt && q.process, M = function() {
  try {
    var e = j && j.require && j.require("util").types;
    return e || x && x.binding && x.binding("util");
  } catch {
  }
}(), N = M && M.isTypedArray, Nt = N ? le(N) : fe;
function se(e, t) {
  return function(o) {
    return e(t(o));
  };
}
r(se, "Ce");
n(se, "overArg");
var Zt = se(Object.keys, Object), _t = Object.prototype, $t = _t.hasOwnProperty;
function pe(e) {
  if (!P(e))
    return Zt(e);
  var t = [];
  for (var o in Object(e))
    $t.call(e, o) && o != "constructor" && t.push(o);
  return t;
}
r(pe, "Me");
n(pe, "baseKeys");
var h = y(i, "Map");
function R(e) {
  return e == null ? "" : E(e);
}
r(R, "rr");
n(R, "toString");
function ye(e, t, o, c) {
  for (var a = -1, Le = e == null ? 0 : e.length; ++a < Le; )
    o = t(o, e[a], a, e);
  return o;
}
r(ye, "Ie");
n(ye, "arrayReduce");
function de(e) {
  return function(t) {
    return e == null ? void 0 : e[t];
  };
}
r(de, "Ue");
n(de, "basePropertyOf");
var Wt = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, Gt = de(Wt), Bt = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Vt = "\\u0300-\\u036f", Ht = "\\ufe20-\\ufe2f", Yt = "\\u20d0-\\u20ff", qt = Vt + Ht + Yt, Jt = "[" + qt + "]", Kt = RegExp(Jt, "g");
function je(e) {
  return e = R(e), e && e.replace(Bt, Gt).replace(Kt, "");
}
r(je, "Ze");
n(je, "deburr");
var Qt = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function ve(e) {
  return e.match(Qt) || [];
}
r(ve, "Ge");
n(ve, "asciiWords");
var Xt = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function ge(e) {
  return Xt.test(e);
}
r(ge, "Je");
n(ge, "hasUnicodeWord");
var xe = "\\ud800-\\udfff", er = "\\u0300-\\u036f", tr = "\\ufe20-\\ufe2f", rr = "\\u20d0-\\u20ff", nr = er + tr + rr, Ae = "\\u2700-\\u27bf", Oe = "a-z\\xdf-\\xf6\\xf8-\\xff", or = "\\xac\\xb1\\xd7\\xf7", ur = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", cr = "\\u2000-\\u206f", ar = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", he = "A-Z\\xc0-\\xd6\\xd8-\\xde", ir = "\\ufe0e\\ufe0f", me = or + ur + cr + ar, Se = "['’]", Z = "[" + me + "]", fr = "[" + nr + "]", Te = "\\d+", lr = "[" + Ae + "]", Ee = "[" + Oe + "]", we = "[^" + xe + me + Te + Ae + Oe + he + "]", br = "\\ud83c[\\udffb-\\udfff]", sr = "(?:" + fr + "|" + br + ")", pr = "[^" + xe + "]", Ie = "(?:\\ud83c[\\udde6-\\uddff]){2}", Ue = "[\\ud800-\\udbff][\\udc00-\\udfff]", s = "[" + he + "]", yr = "\\u200d", _ = "(?:" + Ee + "|" + we + ")", dr = "(?:" + s + "|" + we + ")", $ = "(?:" + Se + "(?:d|ll|m|re|s|t|ve))?", W = "(?:" + Se + "(?:D|LL|M|RE|S|T|VE))?", Pe = sr + "?", Re = "[" + ir + "]?", jr = "(?:" + yr + "(?:" + [pr, Ie, Ue].join("|") + ")" + Re + Pe + ")*", vr = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", gr = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", xr = Re + Pe + jr, Ar = "(?:" + [lr, Ie, Ue].join("|") + ")" + xr, Or = RegExp([
  s + "?" + Ee + "+" + $ + "(?=" + [Z, s, "$"].join("|") + ")",
  dr + "+" + W + "(?=" + [Z, s + _, "$"].join("|") + ")",
  s + "?" + _ + "+" + $,
  s + "+" + W,
  gr,
  vr,
  Te,
  Ar
].join("|"), "g");
function ke(e) {
  return e.match(Or) || [];
}
r(ke, "lt");
n(ke, "unicodeWords");
function ze(e, t, o) {
  return e = R(e), t = t, t === void 0 ? ge(e) ? ke(e) : ve(e) : e.match(t) || [];
}
r(ze, "jt");
n(ze, "words");
var hr = "['’]", mr = RegExp(hr, "g");
function Fe(e) {
  return function(t) {
    return ye(ze(je(t).replace(mr, "")), e, "");
  };
}
r(Fe, "vt");
n(Fe, "createCompounder");
var m = y(i, "DataView"), S = y(i, "Promise"), T = y(i, "Set"), G = "[object Map]", Sr = "[object Object]", B = "[object Promise]", V = "[object Set]", H = "[object WeakMap]", Y = "[object DataView]", Tr = f(m), Er = f(h), wr = f(S), Ir = f(T), Ur = f(A), l = b;
(m && l(new m(new ArrayBuffer(1))) != Y || h && l(new h()) != G || S && l(S.resolve()) != B || T && l(new T()) != V || A && l(new A()) != H) && (l = /* @__PURE__ */ n(function(e) {
  var t = b(e), o = t == Sr ? e.constructor : void 0, c = o ? f(o) : "";
  if (c)
    switch (c) {
      case Tr:
        return Y;
      case Er:
        return G;
      case wr:
        return B;
      case Ir:
        return V;
      case Ur:
        return H;
    }
  return t;
}, "getTag"));
var Pr = "[object Map]", Rr = "[object Set]", kr = Object.prototype, zr = kr.hasOwnProperty;
function Fr(e) {
  if (e == null)
    return !0;
  if (ue(e) && (te(e) || typeof e == "string" || typeof e.splice == "function" || pt(e) || Nt(e) || lt(e)))
    return !e.length;
  var t = l(e);
  if (t == Pr || t == Rr)
    return !e.size;
  if (P(e))
    return !pe(e).length;
  for (var o in e)
    if (zr.call(e, o))
      return !1;
  return !0;
}
r(Fr, "It");
n(Fr, "isEmpty");
var Cr = Fe(function(e, t, o) {
  return e + (o ? "-" : "") + t.toLowerCase();
});
export {
  Cr as U
};
//# sourceMappingURL=awt-0-lodash-D9aVzsWD.js.map
